import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Segment,
  Grid,
  Accordion,
  Icon,
  Button,
  Breadcrumb,
  Table,
} from "semantic-ui-react";
import { isMobile } from "react-device-detect";
import _ from "lodash";
import { parseString } from "xml2js";
import axios from "axios";
import api from "../../api"
import settings, { getApiHost } from "../../settings";
import SearchSubTypes from "./SearchSubTypes";
import NewSearchComponent from "../common/NewSearchComponent";
import HomeValueAndIncomeComponent from "../common/HomeValueAndIncomeComponent";
import getComponentByName from "../searchresults/SearchResultComponentFactory";
import getReportComponentByName from "../../components/reports/SearchReportComponentFactory";
import { encodeUrl } from "../../utils/urlHelper";
import SearchForms from "../searches/SearchForms";
import { expireSession, renewUserToken } from "../../actions/auth";
import { setApiCancelToken } from "../../actions/apiCancelSource";
import {
  addItemToProgress,
  removeItemFromProgress,
  clearProgressList,
} from "../../actions/progressList";
import getNoResult from "../searchresults/NoResult";
import { getErrorMessage } from "../messages/errorMessages";
import { ERR_NO_RECORDS_FOUND } from "../../ErrorMessages";
import SearchLeftForms from "./SearchLeftForms";
import CustomerMessages from "../dialogs/CustomerMessages"
import { uiLoaded } from "../../actions/search";

class SearchComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      activeIndex: 0,
      savedResultID: "",
      searchTypeIndex: 0,
      user: {},
      showDialog: false,
      showNewSearchDialog: false,
      searchText: "",
      popupType: "",
      homeType: "",
      searchResultData: null,
      resultComponent: null,
      selectedRows: [],
      reportComponent: null,
      resultCheckAll: false,
      resultItemState: [],
      resultRecordCount: 0,
      enableReport: false,
      popupMenuData: [],
      showSubTypes: true,
      subMenuItem: null,
      subMenuItems: [],
      leftMenuItem: null,
      leftMenuItems: [],
      searchLoadError: null,
      newFormsData: [],
      report: null,
      searchData: [],
      previewData: [],
      showCancelSearch: false,
      cancelSource: null,
      searchFormsData: [],
      selectedFormIndex: 0,
      currentReportId: undefined,
      currentReportRemainingCount: undefined
    };
    this.updateStateFromProps(this.props, true);
    if (localStorage.searchImmidiate) {
      localStorage.removeItem("searchImmidiate");
      const data = this.state.searchFormsData[this.state.selectedFormId];
      setTimeout(this.showResults.bind(this, this, data, false), 1000);
    }
  }

  componentDidMount = () => {
    localStorage.setItem("sectok", "");
  };

  componentWillReceiveProps = (nextProps) => {
    renewUserToken();
    this.setState({
      searchLoadError: this.updateStateFromProps(nextProps),
    });
  };

  onSearchTypeChanged = (e, tabIndex, menuId) => {
    if (tabIndex >= 0) {
      const { uiData } = this.props;
      this.setState({ searchTypeIndex: tabIndex, selectedFormIndex: 0 });
      const leftMenu = _.find(
        uiData.Menus.MenuItems,
        (a) => a.MenuId === menuId
      );
      if (leftMenu === undefined) {
        this.setState({
          searchLoadError: "The selected page not found",
        });
        return;
      }
      const subMenu = _.find(
        uiData.Menus.MenuItems,
        (a) => a.MenuId === leftMenu.ParentId
      );
      if (subMenu === undefined) {
        this.setState({
          searchLoadError: "The selected page not found",
        });
        return;
      }
      const mainMenu = _.find(
        uiData.Menus.MenuItems,
        (a) => a.MenuId === subMenu.ParentId
      );
      if (mainMenu === undefined) {
        this.setState({
          searchLoadError: "The selected page not found",
        });
        return;
      }
      this.setState({currentReportId: undefined, currentReportRemainingCount: undefined});
      this.props.history.push(
        `/search/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
          subMenu.MenuTitle
        )}/${encodeUrl(leftMenu.MenuTitle)}/${leftMenu.MenuId}`
      );
    }
  };

  onFormDataChange = (formId, formData, currentControlName) => {
    const searchFormsData = this.state.searchFormsData;
    if (currentControlName !== undefined) {
      const rules = _.filter(
        Object.keys(settings.controlRules),
        (rule) => rule === currentControlName
      );
      if (rules !== undefined && rules.length > 0) {
        _.forEach(settings.controlRules[rules[0]], (values, key) => {
          if (key === "remove") {
            _.forEach(values, (value) => {
              delete formData[value];
            });
          } else if (key === "hide") {
            if (formData[currentControlName] === true) {
              _.forEach(values, (value) => {
                delete formData[`hide_${value}`];
              });
            } else {
              _.forEach(values, (value) => {
                formData[`hide_${value}`] = true;
              });
            }
          }
        });
      }
    }

    searchFormsData[formId] = formData;
    this.setState({ searchFormsData, selectedFormId: formId });
  };

  updateStateFromProps = (nextProps, isInitialize) => {
    const pathTokens = decodeURI(nextProps.history.location.pathname).split(
      "/"
    );
    if (pathTokens.length < 4) return <div>Invalid Path</div>;
    const { uiData } = nextProps;
    const topMenuItem = _.find(
      uiData.Menus.MenuItems,
      (a) =>
        a.MenuTitle === pathTokens[2].replace("%2F", "/") && a.MenuLevel === 1
    );
    if (topMenuItem === undefined) return <div>Invalid Top Menu</div>;
    const subMenuItem = _.find(
      uiData.Menus.MenuItems,
      (a) =>
        a.MenuTitle === pathTokens[3].replace("%2F", "/") &&
        a.ParentId === topMenuItem.MenuId &&
        a.MenuLevel === 2
    );
    if (subMenuItem === undefined) return <div>Invalid Sub Menu</div>;
    let leftMenuItem;
    if (pathTokens.length > 5) {
      leftMenuItem = _.find(
        uiData.Menus.MenuItems,
        (a) =>
          a.MenuId === parseInt(pathTokens[5], 10) &&
          a.ParentId === subMenuItem.MenuId &&
          a.MenuLevel === 3
      );
      if (leftMenuItem === undefined) return <div>Invalid Left Menu</div>;
    } else {
      leftMenuItem = _.find(
        uiData.Menus.MenuItems,
        (a) =>
          a.MenuId ===
          uiData.Menus.SubMenuVsLeftMenuItems[subMenuItem.MenuId][0]
      );
    }
    const report = _.find(
      uiData.Reports,
      (a) => a.ReportID === leftMenuItem.ReportId
    );
    const subMenuItems = _.filter(
      uiData.Menus.MenuItems,
      (a) => a.ParentId === subMenuItem.ParentId
    );
    const leftMenuItems = _.filter(
      uiData.Menus.MenuItems,
      (a) => a.ParentId === leftMenuItem.ParentId
    );
    const newFormsData = [];
    _.forEach(leftMenuItem.FormIds, (formId) => {
      const formControls = _.filter(
        uiData.FormData,
        (a) => a.FormId === formId
      );
      newFormsData.push(formControls);
    });
    const searchFormsData = [];
    _.forEach(newFormsData, (formsData) => {
      const formId = formsData[0].FormId;
      const formData = [];
      formData.formID = formId;
      searchFormsData[`Form_${formId}`] = formData;
    });
    let previewSelectedFormId;
    let selectedFormIndex;
    if (localStorage.searchPreviewData) {
      const previewData = JSON.parse(localStorage.searchPreviewData);
      const previewMenuItem = JSON.parse(localStorage.previewMenuItem);
      previewSelectedFormId = previewMenuItem.FormID;
      const previewForm = searchFormsData[`Form_${previewMenuItem.FormID}`];
      if(previewForm && previewData) {
        _.forEach(Object.keys(previewData), (key) => {
          previewForm[key] = previewData[key];
        });
        const prevFormId = parseInt(previewMenuItem.FormID, 10);
        _.forEach(newFormsData, (formsData, index) => {
          if(prevFormId === formsData[0].FormId) {
            selectedFormIndex = index;
          }
        });
      }
      localStorage.removeItem("searchPreviewData");
      localStorage.removeItem("previewMenuItem");
    }
    const customerMessagesDialogActive = localStorage.customerMessages && localStorage.customerMessages !== "";
    if (isInitialize) {
      this.state = {
        topMenuItem,
        subMenuItem,
        subMenuItems,
        leftMenuItem,
        leftMenuItems,
        newFormsData,
        searchFormsData,
        report,
        searchTypeIndex: _.findIndex(
          leftMenuItems,
          (a) => a.MenuId === leftMenuItem.MenuId
        ),
        activeIndex: 0,
        showSubTypes: true,
        resultComponent: null,
        reportComponent: null,
        selectedFormId: `Form_${previewSelectedFormId}`,
        selectedFormIndex,
        customerMessagesDialogActive,
      };
    } else {
      this.setState({
        topMenuItem,
        subMenuItem,
        subMenuItems,
        leftMenuItem,
        leftMenuItems,
        newFormsData,
        searchFormsData,
        report,
        searchTypeIndex: _.findIndex(
          leftMenuItems,
          (a) => a.MenuId === leftMenuItem.MenuId
        ),
        activeIndex: 0,
        showSubTypes: true,
        resultComponent: null,
        reportComponent: null,
        selectedFormId: !previewSelectedFormId
          ? Object.keys(searchFormsData)[0]
          : `Form_${previewSelectedFormId}`,
        selectedFormIndex,
        customerMessagesDialogActive,
      });
    }

    return null;
  };

  updateFormDataValue = (newFormData, storageKey) => {
    if (
      this.state.formData === undefined ||
      localStorage.getItem(storageKey) === undefined ||
      newFormData === undefined ||
      newFormData.formControls === undefined
    )
      return;
    const prevData = JSON.parse(localStorage.getItem(storageKey));
    if (prevData === undefined || prevData === null) {
      return;
    }
    const dataKeys = Object.keys(prevData);

    _.forEach(newFormData.formControls, (newCont) => {
      if (_.find(dataKeys, (a) => a === newCont.controlName) !== undefined) {
        newCont.value = prevData[newCont.controlName];
      }
    });
    localStorage.removeItem(storageKey);
  };

  updateRemainingSearchCount = (reportId) => {
    const payload = { reportId, appName: settings.appName };
    api.lp.getRemainingSearchCount(payload)
      .then((res) => {
        if (res && res.status === 200 && res.data && res.data.Message === "success") {
          const remainingCount = res.data.Data.RemainingCount;
          if (remainingCount !== -2) {
            const uiData = this.props.uiData;
            const report = _.find(uiData.Reports, r => r.ReportID === reportId);
            if (report) {
              report.NumberRemaining = remainingCount;
              localStorage.searchUiData = JSON.stringify(uiData);
              this.props.uiLoaded(uiData);
              this.setState({currentReportId: reportId, currentReportRemainingCount: remainingCount});
            }
          }
        }
      });
  }

  showResults = (e, data, cached) => {
    renewUserToken();
    const { leftMenuItem, subMenuItem, report, resultCheckAll } = this.state;
    const cancelToken = axios.CancelToken;
    const cancelSource = cancelToken.source();
    this.props.userInterruption("search", cancelSource);
    this.props.setApiCancelSource({ type: 1, source: cancelSource });
    this.props.addItemToProgress({ name: "search" });
    this.setState({
      loading: true,
      enableReport: false,
      showCancelSearch: true,
      cancelSource,
      resultComponent: null,
    });
    const payload = {};
    payload.userID = this.props.user.userid;
    _.forEach(Object.keys(data), (key) => {
      if (data[key] !== "-1") payload[key] = data[key];
    });
    if (!payload.radius) {
      payload.radius = 0;
    }
    if (cached) {
      payload.cached = cached;
      delete payload.updateAddress;
    }
    payload.searchBy = leftMenuItem.ParentId;
    payload.searchType = subMenuItem.ParentId;
    payload.reportID = report.ReportID;
    payload.sectok = localStorage.getItem("sectok");
    payload.sserver = settings.appName;
    payload.sessionID = localStorage.getItem("sessionID");
    payload.caseNumber =
      localStorage.getItem("selectedFolderCode") === undefined ||
        localStorage.getItem("selectedFolderCode") === "-1" ||
        localStorage.getItem("selectedFolderCode") === "-2"
        ? ""
        : localStorage.getItem("selectedFolderCode");
    axios
      .post(`${getApiHost(settings.env)}/aSearch.aspx`, payload, {
        cancelToken: cancelSource.token,
      })
      .then((res) => {
        if (!res || !res.data || res.data === "") {
          this.setState({
            activeIndex: 1,
            resultComponent: getNoResult(),
            loading: false,
            resultRecordCount: 0,
            enableReport: false,
            showSubTypes: true,
            showCancelSearch: false,
            cancelSource: null,
            reportComponent: null,
          });
          this.props.workerCompleted("search", cancelSource);
          setTimeout(() => {
            this.props.removeItemFromProgress({ name: "search" });
          }, 500);
          this.updateRemainingSearchCount(report.ReportID);
          return;
        }
        parseString(res.data, { async: false }, (err, result) => {
          const root = Object.keys(result)[0];
          const unhandledError = _.get(result, `${root}.html[0].head[0].title[0]._`);
          const hasError = Object.keys(_.get(result, root))[0] === "error";
          let errorMessage;
          if(unhandledError) errorMessage = "Unable to process, please narrow down search with more criteria."
          if (root === "errors" || hasError) {
            if (hasError)
              localStorage.errorMessage = _.get(
                result,
                `${root}.error[0].errMsg[0]`,
                ""
              );
            else
              localStorage.errorMessage = _.get(
                result,
                `${root}.error[0].errMsg[0]`,
                ""
              );

            errorMessage = getErrorMessage(
              localStorage.errorMessage,
              _.get(result, `${root}.error[0].errMsg[0]`, "")
            );
            const errType = _.get(result, `${root}.error[0].$.errType`);
            if (
              errType === "unauthorized"
            ) {
              this.props.expireSession(errorMessage);
              return;
            }
            if(errType === "emptyactivitydesc") {
              this.setState({
                activeIndex: 1,
                loading: false,
                cancelSource: null,
                errorMessage
              })
              this.props.workerCompleted("search", cancelSource);
              setTimeout(() => {
                this.props.removeItemFromProgress({ name: "search" });
              }, 500);
              return;
            }
          }
          const resultId = _.get(result, `${root}.log[0].actID[0]`);
          let recordCount = _.get(result, `${root}.log[0].actCode[0]`);
          const resultItemState = [];
          if (recordCount !== undefined) {
            recordCount = parseInt(recordCount, 10);
            for (let index = 0; index < recordCount; index += 1) {
              resultItemState[index] = false;
            }
          }
          if ((!errorMessage || errorMessage === "") && recordCount === 0) {
            errorMessage = ERR_NO_RECORDS_FOUND;
          }
          const resultComponent = getComponentByName(
            `${subMenuItem.MenuTitle}/${leftMenuItem.MenuTitle}`,
            result,
            this.handleReportSelection,
            resultCheckAll,
            resultItemState,
            recordCount,
            this.handleNewSearchClick,
            this.handlePreviewNewSearch,
            this.handleHomeValueClick,
            this.handleMapClick,
            this.handleHomeIncomeClick,
            this.showReport,
            this.printContent,
            this.showResults,
            data,
            {
              reportIds: leftMenuItem.ReportIds,
              menuId: leftMenuItem.MenuId,
              errorMessage,
            }
          );
          this.setState({
            savedResultID: resultId,
            searchResultData: result,
            activeIndex: 1,
            resultComponent,
            loading: false,
            resultItemState,
            resultRecordCount: recordCount,
            enableReport: true,
            showSubTypes: true,
            showCancelSearch: false,
            cancelSource: null,
            reportComponent: null,
          });
          this.props.workerCompleted("search", cancelSource);
          this.updateRemainingSearchCount(report.ReportID);
          setTimeout(() => {
            this.props.removeItemFromProgress({ name: "search" });
          }, 500);
        });
      })
      .catch((err) => {
        console.log("Error while fetch results", err);
        const resultComponent = getComponentByName(
            `${subMenuItem.MenuTitle}/${leftMenuItem.MenuTitle}`,
            null,
            this.handleReportSelection,
            null,
            null,
            0,
            this.handleNewSearchClick,
            this.handlePreviewNewSearch,
            this.handleHomeValueClick,
            this.handleMapClick,
            this.handleHomeIncomeClick,
            this.showReport,
            this.printContent,
            this.showResults,
            data,
            {
              errorMessage: "The search results are currently unavailable. Please check the status of your request in My Searches.",
            }
          );
        this.setState({ loading: false, resultComponent, resultRecordCount: 0 });
        if (this.props && this.props.workerCompleted)
          this.props.workerCompleted("search", cancelSource);
        if (this.props && this.props.clearProgressList)
          this.props.clearProgressList();
      });
  };

  clearFormData = (e, data) => {
    const searchFormsData = this.state.searchFormsData;
    searchFormsData[`Form_${data.formID}`] = { formID: data.formID };
    this.setState({ searchFormsData });
  };

  showReport = (reportName, reportApiName, selRow, additionalData) => {
    renewUserToken();
    const cancelToken = axios.CancelToken;
    const cancelSource = cancelToken.source();
    this.props.userInterruption("report", cancelSource);
    this.props.setApiCancelSource({ type: 1, source: cancelSource });
    this.props.addItemToProgress({ name: "report" });
    this.setState({
      loading: true,
      enableReport: false,
      showCancelSearch: true,
      cancelSource,
    });
    const { subMenuItem, leftMenuItem, report } = this.state;
    let addData = _.cloneDeep(additionalData);

    if (addData === undefined) {
      addData = {};
    }

    if (addData.internalID === undefined && addData.lookupID === undefined) {
      const internalID =
        selRow !== undefined && selRow !== ""
          ? selRow
          : _.join(this.state.selectedRows, "|");
      addData.internalID = internalID;
      additionalData.internalID = internalID;
      if (internalID === "") {
        this.setState({ loading: false });
        return null;
      }
    }
    if (addData.ignoreReportId) {
      delete addData.ignoreReportId;
    } else if (addData.reportID === undefined) {
      addData.reportID = report.ReportID;
    }
    addData.userID = this.props.user.userid;
    addData.searchBy = leftMenuItem.ParentId;
    addData.searchType = subMenuItem.ParentId;
    addData.savedResultID = this.state.savedResultID;
    addData.sectok = localStorage.getItem("sectok");
    addData.sserver = settings.appName;
    addData.sessionID = localStorage.getItem("sessionID");

    additionalData.userID = this.props.user.userid;
    additionalData.savedResultID = this.state.savedResultID;
    additionalData.sectok = localStorage.getItem("sectok");
    additionalData.sserver = settings.appName;
    additionalData.sessionID = localStorage.getItem("sessionID");
    additionalData.menuId = leftMenuItem.MenuId;

    if (reportApiName === undefined || reportApiName === "")
      reportApiName = "criminalReport";
    axios
      .post(`${getApiHost(settings.env)}/${reportApiName}.aspx`, addData, {
        cancelToken: cancelSource.token,
      })
      .then((res) => {
        if (!res || !res.data || res.data === "") {
          this.setState({
            activeIndex: 2,
            reportComponent: getNoResult(),
            loading: false,
            resultRecordCount: 0,
            enableReport: false,
            showSubTypes: true,
            showCancelSearch: false,
            cancelSource: null,
          });
          this.props.workerCompleted("report", cancelSource);
          setTimeout(() => {
            this.props.removeItemFromProgress({ name: "report" });
          }, 500);
          return;
        }
        parseString(res.data, { async: false }, (err, result) => {
          const root = Object.keys(result)[0];
          if (root === "errors") {
            const errorMessage = getErrorMessage(
              _.get(result, `${root}.error[0].errMsg[0]`, "")
            );
            const errType = _.get(result, `${root}.error[0].$.errType`);
            if (
              errType === "unauthorized"
            ) {
              localStorage.errorMessage = errorMessage;
              this.props.expireSession(errorMessage);
            }
            if(errType === "emptyactivitydesc") {
              this.setState({
                activeIndex: 2,
                loading: false,
                cancelSource: null,
                errorMessage
              })
              this.props.workerCompleted("report", cancelSource);
              setTimeout(() => {
                this.props.removeItemFromProgress({ name: "report" });
              }, 500);
              return;
            }
          }
          const reportComponent = getReportComponentByName(
            reportName !== undefined && reportName !== ""
              ? reportName
              : `${subMenuItem.MenuTitle}/${leftMenuItem.MenuTitle}`,
            result,
            this.handleNewSearchClick,
            this.handleHomeValueClick,
            this.handleMapClick,
            this.handleHomeIncomeClick,
            additionalData,
            this.props.userInterruption,
            this.showReport,
            this.printContent,
            this.props.history
          );
          this.setState({
            activeIndex: 2,
            reportComponent,
            loading: false,
            showSubTypes: false,
            showCancelSearch: false,
            cancelSource: null,
          });
          this.props.workerCompleted("report", cancelSource);
          setTimeout(() => {
            this.props.removeItemFromProgress({ name: "report" });
          }, 500);
        });
      })
      .catch((err) => {
        console.log("Error while fetch results", err);
        this.setState({ loading: false });
        if (this.props && this.props.workerCompleted)
          this.props.workerCompleted("report", cancelSource);
        if (this.props && this.props.clearProgressList)
          this.props.clearProgressList();
      });

    return null;
  };

  handleReportSelection = (e) => {
    const rows = this.state.selectedRows;
    const row = parseInt(e.target.id, 10);
    if (e.target.checked === true) {
      rows.push(row);
    } else {
      _.remove(rows, (a) => a === row);
    }
    const resultItemState = this.state.resultItemState;
    resultItemState[e.target.id] = e.target.checked;
    const orderedRows = _.orderBy(rows, (v) => v, "asc");
    this.setState({ selectedRows: orderedRows, resultItemState });
  };

  handleClick = (e, titleProps) => {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === titleProps ? -1 : titleProps;
    this.setState({ activeIndex: newIndex, showSubTypes: newIndex < 2 });
  };

  handleHomeValueClick = (e, zip, address) => {
    this.setState({ zip, address, showDialog: true, homeType: "value" });
  };

  popupwindow = (url, title, w, h) => {
    const left = window.width / 2 - w / 2;
    const top = window.height / 2 - h / 2;
    return window.open(
      url,
      title,
      `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`
    );
  };

  handleMapClick = (e, address) => {
    this.popupwindow(
      `https://www.google.com/maps?q=${address}&t=h`,
      "Locateplus Map",
      window.width,
      window.height
    );
  };

  handleHomeIncomeClick = (e, zip, address) => {
    this.setState({ zip, address, showDialog: true, homeType: "income" });
  };

  handleNewSearchClick = (e, type, searchText, data) => {
    this.setState({
      searchText,
      searchData: data,
      showNewSearchDialog: true,
      popupType: type,
    });
  };

  handlePreviewNewSearch = (e, option, data, menuItem) => {
    this.setState({ showNewSearchDialog: false });
    localStorage.searchPreviewData = this.customArryToJson(data);
    localStorage.previewMenuItem = this.customArryToJson(menuItem);
    this.toggleSubtype();
    const resultComponent = getComponentByName("");
    const reportComponent = getReportComponentByName("");
    this.setState({
      previewData: this.customArryToJson(data),
      activeIndex: 0,
      resultComponent,
      reportComponent,
    });
    this.props.history.push(
      `/search/${encodeUrl(option.category)}/${encodeUrl(
        option.groupType
      )}/${encodeUrl(option.value)}/${option.menuId}`
    );
  };

  handleNewSearchDialogClose = () => {
    this.setState({ showNewSearchDialog: false });
  };

  handleHomeValueClose = () => {
    this.setState({ showDialog: false });
  };

  handleFormChange = (index) => {
    this.setState({ selectedFormIndex: index });
  };

  toggleSubtype = () => {
    this.setState({ showSubTypes: !this.state.showSubTypes });
  };

  customArryToJson = (data) => {
    let str = "";
    _.forEach(Object.keys(data), (key) => {
      str = `${str}${str.length > 0 ? "," : ""}"${key}":"${data[key]}"`;
    });
    return `{${str}}`;
  };

  closeCusomerMessagesDialog = () => {
    localStorage.removeItem("customerMessages");
    this.setState({ customerMessagesDialogActive: false });
  }

  printContent = (divId, title) => {
    const content = document.getElementById(divId).innerHTML;
    const printTitle = `${settings.appName.charAt(0).toUpperCase() +
      settings.appName.slice(1)} ${title}`;
    const mywindow = window.open("", printTitle, "height=600,width=800");

    mywindow.document.write(
      `<!DOCTYPE html><html><head><title>${printTitle}</title>`
    );
    mywindow.document.write(
      `<style>.no-print{display: none;} 
     </style>`
    );
    mywindow.document.write(
      `<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />`
    );
    mywindow.document.write(
      `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/semantic-ui@2.4.2/dist/semantic.min.css" />`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/bootstrap-table-extra.css">`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/App.css">`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/main.css">`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/print-media.css">`
    );
    mywindow.document.write(
      `<link rel="stylesheet" type="text/css" href="/sub-table.css">`
    );
    mywindow.document.write("</head><body>");
    mywindow.document.write(content);
    mywindow.document.write("</body></html>");

    mywindow.document.close();
    mywindow.focus();
    mywindow.onload = () => {
      setTimeout(() => {
        mywindow.print();
        mywindow.close();
      }, 1000);
    };
  };

  mobileViewWidth = () => {
    if (isMobile) {
      return 16;
    }
    return this.state.showSubTypes ? 11 : 16;
  };

  render() {
    const activeIndex = this.state.activeIndex;
    const { uiData, userAccount } = this.props;
    const {
      topMenuItem,
      subMenuItem,
      subMenuItems,
      leftMenuItem,
      leftMenuItems,
      searchTypeIndex,
      searchLoadError,
      newFormsData,
      errorMessage,
    } = this.state;
    let mobileView = false;
    if (subMenuItems.length < 1) {
      if (searchLoadError !== "") return <div>{searchLoadError}</div>;
      return <div>Page not found</div>;
    }

    if (isMobile) {
      mobileView = true;
    }
    const hideFormRightSection = false;
    const hasReport =
      leftMenuItem &&
      leftMenuItem !== null &&
      leftMenuItem.ReportIds &&
      leftMenuItem.ReportIds !== null;
    return (
      <div>
        <div>
          <div className="col-lg-12 col-sm-12">
            <div className="row">
              <Segment key="tabContent1" attached loading={this.state.loading}>
                {/* <div className="row">
                <div className="col-sm-12"> */}
                <Breadcrumb>
                  <Breadcrumb.Section link>
                    <span
                      role="menu"
                      tabIndex={-1}
                      style={{ cursor: "pointer", color: "#4183c4" }}
                      onClick={() =>
                        this.props.history.push(
                          `/search/${encodeUrl(
                            topMenuItem.MenuTitle
                          )}/${encodeUrl(subMenuItems[0].MenuTitle)}`
                        )
                      }
                    >
                      {topMenuItem.MenuTitle}
                    </span>
                  </Breadcrumb.Section>
                  <Breadcrumb.Divider />
                  <Breadcrumb.Section active>
                    <span
                      role="menu"
                      tabIndex={-2}
                      style={{ cursor: "pointer", color: "#4183c4" }}
                      onClick={(e) => {
                        this.onSearchTypeChanged(e, 0, leftMenuItems[0].MenuId);
                      }}
                    >
                      {subMenuItem.MenuTitle}
                    </span>
                    {`: ${leftMenuItem.MenuTitle}`}
                  </Breadcrumb.Section>
                </Breadcrumb>
                {/* </div>
              </div> */}
                <Grid stackable>
                  {this.state.showSubTypes ? (
                    <Grid.Column
                      className={mobileView ? "no-padding" : ""}
                      width={mobileView ? "16" : "5"}
                    >
                      {userAccount.acctTheme === 0 && activeIndex === 1 && (
                        <Table className="table-no-border-and-padding no-print">
                          <Table.Body>
                            <Table.Row>
                              <Table.Cell>
                                <SearchLeftForms
                                  newFormsData={newFormsData}
                                  submit={this.showResults}
                                  clear={this.clearFormData}
                                  previewData={this.state.previewData}
                                  searchFormsData={this.state.searchFormsData}
                                  selectedFormId={this.state.selectedFormId}
                                  selectedFormIndex={
                                    this.state.selectedFormIndex
                                  }
                                  onFormDataChange={this.onFormDataChange}
                                  currentMenuHierarchy={[
                                    subMenuItem && subMenuItem.MenuTitle,
                                    leftMenuItem && leftMenuItem.MenuTitle,
                                  ]}
                                  leftMenuReportId={leftMenuItem.ReportId}
                                  searchTypeIndex={searchTypeIndex}
                                  onSearchTypeChanged={this.onSearchTypeChanged}
                                  selectedSubMenu={subMenuItem}
                                  selectedLeftMenu={leftMenuItem}
                                  reports={uiData.Reports}
                                  subMenuItems={subMenuItems}
                                  leftMenuItems={leftMenuItems}
                                  history={this.props.history}
                                />
                              </Table.Cell>
                              {!mobileView && (
                                <Table.Cell className={"vertical-align-top"}>
                                  <Button
                                    onClick={this.toggleSubtype}
                                    size={"tiny"}
                                    circular
                                    className={
                                      "float-right close-left-menu-button"
                                    }
                                  >
                                    {this.state.showSubTypes ? "<" : ">"}
                                  </Button>
                                </Table.Cell>
                              )}
                            </Table.Row>
                          </Table.Body>
                        </Table>
                      )}
                      {(userAccount.acctTheme === 1 ||
                        (userAccount.acctTheme === 0 && activeIndex === 0)) && (
                          <Table className="table-no-border-and-padding no-print">
                            <Table.Body>
                              <Table.Row>
                                <Table.Cell>
                                  <SearchSubTypes
                                    searchTypeIndex={searchTypeIndex}
                                    onSearchTypeChanged={this.onSearchTypeChanged}
                                    selectedSubMenu={subMenuItem}
                                    selectedLeftMenu={leftMenuItem}
                                    reports={uiData.Reports}
                                    subMenuItems={subMenuItems}
                                    leftMenuItems={leftMenuItems}
                                    history={this.props.history}
                                    className={"float-left"}
                                    acctTheme={userAccount.acctTheme}
                                    currentReportId={this.state.currentReportId}
                                    currentReportRemainingCount={this.state.currentReportRemainingCount}
                                  />
                                </Table.Cell>
                                {!mobileView && (
                                  <Table.Cell className={"vertical-align-top"}>
                                    <Button
                                      onClick={this.toggleSubtype}
                                      size={"tiny"}
                                      circular
                                      className={
                                        "float-right close-left-menu-button"
                                      }
                                    >
                                      {this.state.showSubTypes ? "<" : ">"}
                                    </Button>
                                  </Table.Cell>
                                )}
                              </Table.Row>
                            </Table.Body>
                          </Table>
                        )}
                    </Grid.Column>
                  ) : null}
                  <Grid.Column
                    width={this.mobileViewWidth()}
                    className={mobileView ? "padding-top-20" : null}
                  >
                    <Table className="border-none table-no-padding">
                      <Table.Body>
                        <Table.Row>
                          {!(
                            userAccount.acctTheme === 0 && activeIndex === 2
                          ) &&
                            !mobileView &&
                            !this.state.showSubTypes && (
                              <Table.Cell className={"vertical-align-top"}>
                                <Button
                                  onClick={this.toggleSubtype}
                                  size={"tiny"}
                                  circular
                                  className={
                                    "float-right close-left-menu-button"
                                  }
                                >
                                  {this.state.showSubTypes ? "<" : ">"}
                                </Button>
                              </Table.Cell>
                            )}
                          <Table.Cell>
                            {userAccount.acctTheme === 1 && (
                              <Accordion
                                fluid
                                styled
                                className={"search-accordion"}
                              >
                                <Accordion.Title
                                  active={activeIndex === 0}
                                  key={"SearchFormsTitle"}
                                  onClick={(e) => this.handleClick(e, 0)}
                                >
                                  <Icon name="dropdown" />
                                  Search
                                </Accordion.Title>
                                <Accordion.Content
                                  key="SearchForms"
                                  active={activeIndex === 0}
                                  className={"no-padding"}
                                >
                                  <SearchForms
                                    newFormsData={newFormsData}
                                    submit={this.showResults}
                                    clear={this.clearFormData}
                                    previewData={this.state.previewData}
                                    searchFormsData={this.state.searchFormsData}
                                    selectedFormId={this.state.selectedFormId}
                                    selectedFormIndex={
                                      this.state.selectedFormIndex
                                    }
                                    acctTheme={userAccount.acctTheme}
                                    onFormDataChange={this.onFormDataChange}
                                    onFormChange={this.handleFormChange}
                                    currentMenuHierarchy={[
                                      subMenuItem && subMenuItem.MenuTitle,
                                      leftMenuItem && leftMenuItem.MenuTitle,
                                    ]}
                                    leftMenuReportId={leftMenuItem.ReportId}
                                    hideFormRightSection={hideFormRightSection}
                                  />
                                </Accordion.Content>
                                <Accordion.Title
                                  active={activeIndex === 1}
                                  key={"SearchResultTitle"}
                                  onClick={(e) => this.handleClick(e, 1)}
                                >
                                  <Icon name="dropdown" />
                                  Search Result
                                </Accordion.Title>
                                <Accordion.Content
                                  key={"SearchResult"}
                                  active={activeIndex === 1}
                                >
                                  {this.state.resultComponent ? (
                                    <div id="result">
                                      {this.state.resultComponent}
                                    </div>
                                  ) : (
                                    <center>
                                      {errorMessage}
                                      <br />
                                    </center>
                                  )}
                                </Accordion.Content>
                                {hasReport && (
                                  <Accordion.Title
                                    active={activeIndex === 2}
                                    key={"SearchReportTitle"}
                                    onClick={(e) => this.handleClick(e, 2)}
                                  >
                                    <Icon name="dropdown" />
                                    Report
                                  </Accordion.Title>
                                )}
                                {hasReport && (
                                  <Accordion.Content
                                    key={"SearchReport"}
                                    active={activeIndex === 2}
                                  >
                                    {this.state.reportComponent ? (
                                      this.state.reportComponent
                                    ) : (
                                      <center>
                                        {errorMessage}
                                        <br />
                                      </center>
                                    )}
                                  </Accordion.Content>
                                )}
                              </Accordion>
                            )}
                            {userAccount.acctTheme === 0 && activeIndex === 0 && (
                              <Segment>
                                <SearchForms
                                  newFormsData={newFormsData}
                                  submit={this.showResults}
                                  clear={this.clearFormData}
                                  previewData={this.state.previewData}
                                  searchFormsData={this.state.searchFormsData}
                                  acctTheme={userAccount.acctTheme}
                                  selectedFormId={this.state.selectedFormId}
                                  selectedFormIndex={
                                    this.state.selectedFormIndex
                                  }
                                  onFormDataChange={this.onFormDataChange}
                                  onFormChange={this.handleFormChange}
                                  currentMenuHierarchy={[
                                    subMenuItem && subMenuItem.MenuTitle,
                                    leftMenuItem && leftMenuItem.MenuTitle,
                                  ]}
                                  leftMenuReportId={leftMenuItem.ReportId}
                                  hideFormRightSection={hideFormRightSection}
                                />
                              </Segment>
                            )}
                            {userAccount.acctTheme === 0 &&
                              activeIndex === 1 &&
                              this.state.resultComponent ? (
                              <Segment>
                                <div id="result">
                                  {this.state.resultComponent}
                                </div>
                              </Segment>
                            ) : (
                              <span />
                            )}
                            {userAccount.acctTheme === 0 &&
                              activeIndex === 2 &&
                              this.state.reportComponent ? (
                              this.state.reportComponent
                            ) : (
                              <span />
                            )}
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Grid.Column>
                </Grid>
              </Segment>

              <HomeValueAndIncomeComponent
                zip={this.state.zip}
                address={this.state.address}
                showDialog={this.state.showDialog}
                handleHomeValueClose={this.handleHomeValueClose}
                homeType={this.state.homeType}
              />

              <NewSearchComponent
                searchText={this.state.searchText}
                searchData={this.state.searchData}
                dialogClose={this.handleNewSearchDialogClose}
                active={this.state.showNewSearchDialog}
                previewNewSearch={this.handlePreviewNewSearch}
                popupType={this.state.popupType}
              />
              {localStorage.customerMessages && localStorage.customerMessages !== "" &&
                (<CustomerMessages title="Important Message"
                  active={this.state.customerMessagesDialogActive} messages={JSON.parse(localStorage.customerMessages)}
                  dialogClose={this.closeCusomerMessagesDialog} />)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, {
  expireSession,
  setApiCancelSource: setApiCancelToken,
  addItemToProgress,
  removeItemFromProgress,
  clearProgressList,
  uiLoaded,
})(SearchComponent);



// WEBPACK FOOTER //
// ./src/components/searches/SearchComponent.js